import React from "react";
import { Container } from 'react-bootstrap';

import WOW from "wowjs";

class Hero extends React.Component {

	componentDidMount() {
    	new WOW.WOW().init();
  	}
  	render() {
		return (
			<div className="HereoBanner automotive-back">
			    <div className="Banner_Content">
					<Container fluid>
						<h2 className="pagehead-title wow fadeInUp">HEALTHCARE</h2>
						<div className="red-border"> </div>
						<p>Making tomorrow's healthcare industry more effective, efficient and affordable by building solutions that strongly impacts healthcare organizations.</p>
					</Container>
				</div>
			</div>
		);
	}
};

export default Hero;
